export default __webpack_public_path__ + "static/wamo-text-0e90e8f527e333c930e7b3b6e115456e.jpg";